var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniSchool01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.746094,
    y: 0.453125,
    width: 258,
    height: 252,
    fill: "#D6895E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_500_11918",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.746094,
    y: 0.453125,
    width: 258,
    height: 252,
    fill: "#D6895E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_500_11918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.8086 57.6934C89.8086 55.4842 91.5995 53.6934 93.8086 53.6934H269.057C271.266 53.6934 273.057 55.4842 273.057 57.6934V185.74H89.8086V57.6934Z",
    fill: "#112D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8926 65.7773C97.8926 63.5682 99.6834 61.7773 101.893 61.7773H260.972C263.181 61.7773 264.972 63.5682 264.972 65.7773V183.044H97.8926V65.7773Z",
    fill: "#357280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.814 173.083V163.557H230.209C232.426 163.557 233.512 164.886 233.512 166.649C233.512 168.405 232.42 169.741 230.209 169.741H228.262V173.083H226.814ZM228.262 168.504H230.065C231.466 168.511 232.051 167.721 232.051 166.649C232.051 165.57 231.466 164.8 230.065 164.794H228.262V168.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.394 173.175C234.881 173.169 234.453 172.754 234.459 172.241C234.453 171.728 234.881 171.307 235.394 171.307C235.9 171.307 236.321 171.728 236.328 172.241C236.321 172.754 235.9 173.169 235.394 173.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.144 173.083V163.557H241.539C243.756 163.557 244.841 164.886 244.841 166.649C244.841 168.405 243.749 169.741 241.539 169.741H239.591V173.083H238.144ZM239.591 168.504H241.394C242.795 168.511 243.381 167.721 243.381 166.649C243.381 165.57 242.795 164.8 241.394 164.794H239.591V168.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.657 163.557V173.083H246.249V163.557H247.657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.447 173.228C250.342 173.228 249.045 171.774 249.052 169.557C249.045 167.359 250.361 165.846 252.355 165.846C253.98 165.846 255.526 166.853 255.526 169.438V169.938H250.447C250.486 171.3 251.289 172.07 252.46 172.07C253.256 172.07 253.776 171.728 254.013 171.294H255.434C255.118 172.452 254.019 173.228 252.447 173.228ZM250.453 168.886H254.144C254.144 167.8 253.44 166.998 252.368 167.004C251.243 166.998 250.513 167.879 250.453 168.886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.1133,
    y: 183.045,
    width: 188.638,
    height: 16.1689,
    rx: 4,
    fill: "#112D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1133 187.045C87.1133 184.836 88.9041 183.045 91.1133 183.045H271.751C273.96 183.045 275.751 184.836 275.751 187.045V188.435H87.1133V187.045Z",
    fill: "#3E98A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.973 183.044V65.7773C264.973 63.5682 263.182 61.7773 260.973 61.7773H106.516L251.744 183.044H264.973Z",
    fill: "#1D4953",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.414 242.453V222.656H190.18C194.678 222.656 197.262 225.432 197.262 229.328C197.262 233.279 194.637 236 190.07 236H186.516V242.453H182.414ZM186.516 232.691H189.414C191.848 232.691 193.037 231.324 193.023 229.328C193.037 227.359 191.848 226.033 189.414 226.02H186.516V232.691ZM201.227 242.699C199.941 242.699 198.902 241.674 198.93 240.402C198.902 239.145 199.941 238.119 201.227 238.133C202.443 238.119 203.496 239.145 203.496 240.402C203.496 241.674 202.443 242.699 201.227 242.699ZM206.832 242.453V222.656H214.598C219.096 222.656 221.68 225.432 221.68 229.328C221.68 233.279 219.055 236 214.488 236H210.934V242.453H206.832ZM210.934 232.691H213.832C216.266 232.691 217.455 231.324 217.441 229.328C217.455 227.359 216.266 226.033 213.832 226.02H210.934V232.691ZM228.242 222.656V242.453H224.195V222.656H228.242ZM238.113 242.754C233.561 242.74 230.771 239.801 230.785 235.098C230.771 230.518 233.602 227.414 237.949 227.414C241.846 227.414 244.922 229.875 244.922 234.934V236.082H234.777C234.777 238.324 236.104 239.705 238.195 239.719C239.576 239.705 240.561 239.104 240.957 238.215H244.812C244.238 240.963 241.777 242.74 238.113 242.754ZM234.777 233.539H241.094C241.08 231.734 239.836 230.436 238.031 230.449C236.172 230.436 234.859 231.83 234.777 233.539Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniSchool01);
export default __webpack_public_path__ + "static/media/mini_school_01.77e2c3c6c8cf6259848816257bc36f16.svg";
export { ForwardRef as ReactComponent };